export default {
  defaulttab:""
}


// WEBPACK FOOTER //
// ./src/common/js/Global.js